import { render } from "./RightPane.vue?vue&type=template&id=15a609aa&scoped=true"
import script from "./RightPane.vue?vue&type=script&lang=js"
export * from "./RightPane.vue?vue&type=script&lang=js"

import "./RightPane.vue?vue&type=style&index=0&id=15a609aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a609aa"]])

export default __exports__